import BaseView from './BaseView';
import FaqModule from '../../components/FaqModule';

let view = null;

class HomeView extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {
		this.container.querySelectorAll('[data-faq]').forEach((component) => {
			this.components.push(new FaqModule(component));
		});
	}

	destroy() {
		super.destroy();
	}
}

export default {
	namespace: 'template-home',
	beforeEnter: ({ current, next, trigger }) => {
		view = new HomeView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
